import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'wiz-menuentry-media',
  styleUrl: 'menu-entry.scss',
  shadow: true,
})
export class MenuEntryMedia {
  @Prop() apiDomain!: string;
  @Prop() img!: string;
  @Prop() link!: string;
  @Prop() title!: string;
  @Prop() trackClicked!: () => void;

  render() {
    return (
      <a onClick={() => this.trackClicked()} class="menu-entry" href={this.link} target="_blank" rel="noopener">
        <img class="menu-entry__image" src={this.img} alt="" />
        <span class="menu-entry__description">{this.title}</span>
      </a>
    );
  }
}
